import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import './style.scss';

class UserInitials extends Component {
    render() {
        const {className, fullName = ''} = this.props;
        const initials = fullName.split(' ').slice(0, 2).map(l => l.slice(0, 1)).join('');
        return <div className={`avatar-initials ${className || ''}`}><span>{initials}</span></div>;
    }
}

UserInitials.propTypes = {
    fullName: PropTypes.string,
    className: PropTypes.string
};

export default observer(UserInitials);
